module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-ExtraBold.703ce8b.woff";